"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var SoundCloud = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M13,8 C14.9356672,8 16.5502049,9.37491926 16.9202731,11.2014179 C19.4237683,10.3920421 21.0001051,12.3431458 21.0001051,14 C21.0001051,15.5976809 19.7460179,17 18,17 L10,17 L10,17 L9.9997307,9.35474757 C10.7323745,8.52403332 11.80499,8 13,8 Z M5.00151619,12.0503173 L5,17 L4,17 L4.00057405,12.0498926 C4.16195106,12.0171744 4.83949129,12.017323 5.00151619,12.0503173 Z M9.00043252,10.0355063 L9,17 L8,17 L8.0001122,10.0354291 C8.1633774,10.0120805 8.83699328,10.0121073 9.00043252,10.0355063 Z M7.00028038,10.3367149 L7,17 L6,17 L5.9999017,11.0508917 C6.28701089,10.7577112 6.62528684,10.5148445 7.00028038,10.3367149 Z M3.00004507,12.4997831 L3.00014782,16.5002941 C2.3928404,16.0441978 2,15.3179753 2,14.5 C2,13.6820708 2.39279608,12.9558841 3.00004507,12.4997831 Z" })));
};
SoundCloud.displayName = 'SoundCloud';
exports.default = SoundCloud;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=SoundCloud.js.map